import { notification } from "antd";
import { ApolloError } from "apollo-client";
import { useState } from "react";
import { Api } from "../../common/Api";

export const useEditDivision = ({ refresh }) => {
  const [visible, setVisible] = useState(false);
  const [saving, setSaving] = useState(false);
  const [model, setModel] = useState<any>();

  const edit = (model) => {
    const { id, name, regionId, zoneId, directorId, directorIds } = model;
    setModel({ id, name, regionId, zoneId, directorId, directorIds });
    setVisible(true);
  };

  const save = (values) => {
    setSaving(true);
    return Api.division
      .save({ id: model.id, ...values })
      .then((res) => {
        setVisible(false);
        notification.success({ message: `Division ${values.name} saved` });
        refresh();
      })
      .catch((err: ApolloError) => {})
      .finally(() => setSaving(false));
  };

  const close = () => {
    setVisible(false);
  };

  return {
    visible,
    saving,
    model,
    edit,
    save,
    close,
  };
};
